import { Children, cloneElement } from 'react';

import type { FC, ReactElement } from 'react';

export interface RepeatProps {
  count: number;
  children: ReactElement;
}

/**
 * repeat an Element by count {number}
 */
export const Repeat: FC<RepeatProps> = ({ count = 0, children }) => {
  const Child = Children.only(children);

  return (
    <>
      {Array.from({ length: count }, (_, index) =>
        cloneElement(Child, {
          key: index,
          index,
        })
      )}
    </>
  );
};
